export class Response {
    constructor(data, status = 200, message) {
        this.data = data;
        this.status = status;
        this.message = message;
    }
}



// WEBPACK FOOTER //
// ./src/services/api/utils/providerResponse.js